import { createSlice } from '@reduxjs/toolkit';
import api from 'src/api/index';

const initialState = {
	unreadCount: 0,
};

const chatSlice = createSlice({
	name: 'chat',
	initialState,
	reducers: {
		setUnreadCount: (state, action) => {
			state.unreadCount = action.payload;
		},
	},
});

export const { setUnreadCount } = chatSlice.actions;

export const fetchUnreadCount = () => async (dispatch) => {
	try {
		const res = await api.chatList({ limit: 1 });
		dispatch(setUnreadCount(res?.totalUnreadCount || 0));
	} catch (e) {
		// Молча игнорируем — не критично для фонового полинга
	}
};

export default chatSlice.reducer;
